import axios from 'axios'
import domain from '@/assets/js/domain'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'

// 生成请求实例
let server = axios.create({
  baseURL: domain,
  timeout: 30000
})
// 请求之前验证
server.interceptors.request.use(config => {
  config.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
  let token = window.sessionStorage.getItem('token')
  if (token) {
    config.headers.common.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 处理返回的数据
server.interceptors.response.use(response => {
  if (response.status === 200) {
    if (response.data.code === '0') {
      return response.data
    } else if (response.data.code === '-101') {
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('code')
      Toast.fail('身份认证未通过,请重新进入')
      setTimeout(function () {
        wx.closeWindow()
      }, 2000)
      // window.location.replace(window.location.href.split('?')[0] + '#' + window.location.href.split('#')[1])
      return Promise.reject(response.data)
    } else {
      return Promise.reject(response.data)
    }
  }
}, () => {
  const err = {
    msg: '网络错误'
  }
  return Promise.reject(err)
})

export default server



// WEBPACK FOOTER //
// ./src/assets/js/service.js